import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DatatableComponent } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-form-wrapper-builder',
  templateUrl: './form-wrapper-builder.component.html',
  styleUrls: ['./form-wrapper-builder.component.scss']
})
export class FormWrapperBuilderComponent implements OnInit, OnChanges {
  dynamicForm: FormGroup;
  submitted: boolean = false;

  @Input() formHeading: string = 'Default Form'
  @Input() formFields: Array<any> = new Array<any>;
  @Input() setFormData: any = null;
  @Output() formSubmitEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() hideEditView: boolean = true;
  @Input() hideEditViewIntentionaly: boolean = false;
  @Input() hideCancelButton:boolean = false;
  @Input() nameOfSubmitBtb:string = 'Save';
  @Output() changeFormCallbackEmitter:EventEmitter<any> = new EventEmitter<any>();
  constructor(private formBuilder: FormBuilder, private cdRef: ChangeDetectorRef) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    this.setData();
  }

  get f() { return this.dynamicForm.controls; }

  ngOnInit(): void {
    this.createForm();
    this.setData();
  }


  private setData() {
    if (this.setFormData != null && this.dynamicForm) {
      this.dynamicForm.patchValue(this.setFormData);
      this.hideForm();
    }else{
      this.showForm();
    }
  }

  private createForm() {
    const group = {};

    // Loop through each field configuration to create the form control with validators
    this.formFields.forEach(field => {
      group[field.name] = ['', field.validators];  // Add form control with initial value and validators
    });

    this.dynamicForm = this.formBuilder.group(group)
  }


  private initializeSellerFormDetails() {
    this.formFields = [
      { name: 'name', label: 'Name', type: 'text', placeholder: 'Enter your name', validators: [Validators.required] },
      { name: 'age', label: 'Age', type: 'text', placeholder: 'Enter your age', validators: [] },
      { name: 'occupation', label: 'Occupation', type: 'text', placeholder: 'Enter your occupation', validators: [] },
      { name: 'address', label: 'Address', type: 'text', placeholder: 'Enter your address', validators: [] }
    ];
    this.createForm();
  }


  onSubmit() {
    if (this.dynamicForm.valid) {
      console.log(this.dynamicForm.value);
      this.formSubmitEvent.emit(this.dynamicForm.value);
    } else {
      this.formSubmitEvent.emit(null);
    }
  }

  resetForm() {
    this.dynamicForm.reset();
  }

  showForm() {
    this.hideEditView = false;
  }

  hideForm() {
    this.hideEditView = true;

  }
  changeFormCallback(){
    this.changeFormCallbackEmitter.emit(this.dynamicForm);
  }

  disableWheel(event:WheelEvent){
    event.preventDefault();
  }

}
